import React from 'react'
import CardioExamsList from './CardioExams/CardioExamsList'
import ConsultationsList from './Conslultations/ConsultationsList'
import SpecReviewsList from './SpecReviews/SpecReviewsList'
import OtherExamsList from './OtherExams/OtherExamsList'
import TelecomExamsList from './TelecomExams/TelecomExamsList'

export default function Exams() {
  return (
    <div>
      <CardioExamsList />
      <OtherExamsList />
      <SpecReviewsList />
      <ConsultationsList />
      <TelecomExamsList />
    </div>
  )
}
